export const GET_SAGE_TOKEN = gql`
    mutation GET_SAGE_TOKEN($code: String!) {
        getSageToken(code: $code) {
            status
        }
    }
`;
